export default __webpack_public_path__ + "files/FP1_F_UNDING_INSTRUMENTS_FOR_INNOVATIVE_BIO_BASED_SOLUTIONS.pdf";